import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "px-3" }
const _hoisted_3 = { class: "px-3" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "text-base font-bold" }
const _hoisted_7 = { class: "my-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "mr-3 text-base" }, "Catalog type number", -1)
const _hoisted_9 = { class: "text-base" }
const _hoisted_10 = { class: "py-3" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { class: "mt-3 text-right" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slot_error = _resolveComponent("slot-error")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_UploadDesign = _resolveComponent("UploadDesign")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_ctx.product)
    ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0,
        gutter: 20,
        class: "mapping-variant"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_el_image, {
                        style: {"width":"100px","height":"auto"},
                        src: _ctx.imageUrl(_ctx.product.mockup),
                        "preview-src-list": [_ctx.imageUrl(_ctx.product.mockup)],
                        "initial-index": 1
                      }, {
                        error: _withCtx(() => [
                          _createVNode(_component_slot_error)
                        ]),
                        _: 1
                      }, 8, ["src", "preview-src-list"])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.product.title), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.product.variants.length) + " variants", 1)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_card, { class: "mt-3 variant-container" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.variants, (v, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      onClick: ($event: any) => (_ctx.onClickVariant(v)),
                      class: _normalizeClass(["cursor-pointer", { 'font-bold': _ctx.state.variantMapping.sku === v.sku }])
                    }, [
                      _createElementVNode("p", null, _toDisplayString(v.title), 1),
                      _createVNode(_component_el_divider)
                    ], 10, _hoisted_5))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.state.variantMapping)
            ? (_openBlock(), _createBlock(_component_el_col, {
                key: 0,
                span: 16
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.state.variantMapping.title), 1),
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.state.catalogTypeNumber,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.catalogTypeNumber) = $event)),
                          onChange: _ctx.onChangeCatalogNumber,
                          placeholder: "Select catalog type number"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (i) => {
                              return _createVNode(_component_el_option, {
                                key: i,
                                label: i,
                                value: i
                              }, null, 8, ["label", "value"])
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"]),
                        _createVNode(_component_el_divider),
                        _createVNode(_component_el_collapse, {
                          accordion: "",
                          class: "collapse-catalog"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.variantMapping.catalogs, (c, i) => {
                              return (_openBlock(), _createBlock(_component_el_collapse_item, {
                                key: i,
                                title: `Catalog ${i + 1}`
                              }, {
                                title: _withCtx(() => [
                                  _createVNode(_component_el_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_col, { span: 8 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_9, "Catalog " + _toDisplayString(i + 1), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_el_col, { span: 16 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            placeholder: "Select a catalog",
                                            modelValue: c.catalogId,
                                            "onUpdate:modelValue": ($event: any) => ((c.catalogId) = $event)
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogs, (cate) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: cate._id,
                                                  label: cate.name,
                                                  value: cate._id
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createVNode(_component_el_row, null, {
                                      default: _withCtx(() => [
                                        (
                      _ctx.catalogs && _ctx.catalogs.find(ca => ca._id === c.catalogId)
                    )
                                          ? (_openBlock(), _createBlock(_component_el_col, {
                                              key: 0,
                                              span: 12
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_row, null, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogs.find(
                          ca => ca._id === c.catalogId
                        ).designs.length, (ide) => {
                                                      return (_openBlock(), _createBlock(_component_el_col, {
                                                        span: 12,
                                                        class: "p-3",
                                                        key: ide
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_11, "Artwork " + _toDisplayString(ide), 1),
                                                          _createVNode(_component_UploadDesign, {
                                                            index: ide - 1,
                                                            indexCatalog: i,
                                                            onOnUploadFileDesign: _ctx.onUploadFileDesign
                                                          }, null, 8, ["index", "indexCatalog", "onOnUploadFileDesign"]),
                                                          (
                            c.designs[ide - 1] && c.designs[ide - 1].designSrc
                          )
                                                            ? (_openBlock(), _createBlock(_component_el_image, {
                                                                key: 0,
                                                                class: "my-3",
                                                                style: {"width":"80px","height":"auto"},
                                                                src: _ctx.imageUrl(c.designs[ide - 1].designSrc),
                                                                "preview-src-list": [
                            _ctx.imageUrl(c.designs[ide - 1].designSrc),
                          ],
                                                                "initial-index": 1
                                                              }, {
                                                                error: _withCtx(() => [
                                                                  _createVNode(_component_slot_error)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["src", "preview-src-list"]))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    }), 128))
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true),
                                        (
                      _ctx.catalogs && _ctx.catalogs.find(ca => ca._id === c.catalogId)
                    )
                                          ? (_openBlock(), _createBlock(_component_el_col, {
                                              key: 1,
                                              span: 12
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_form, { "label-width": "120px" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_form_item, { label: "Quantity" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_el_select, {
                                                          modelValue: c.quantity,
                                                          "onUpdate:modelValue": ($event: any) => ((c.quantity) = $event),
                                                          placeholder: "Select quantity"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (i) => {
                                                              return _createVNode(_component_el_option, {
                                                                key: i,
                                                                label: i,
                                                                value: i
                                                              }, null, 8, ["label", "value"])
                                                            }), 64))
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    (
                          _ctx.catalogs &&
                          _ctx.catalogs.find(ca => ca._id === c.catalogId)
                        )
                                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                          key: 0,
                                                          label: "Color"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_el_select, {
                                                              modelValue: c.color,
                                                              "onUpdate:modelValue": ($event: any) => ((c.color) = $event),
                                                              placeholder: "Select color"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogs.find(
                              ca => ca._id === c.catalogId
                            ).colors, (co) => {
                                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                                    key: co.code,
                                                                    label: co.name,
                                                                    value: co.code
                                                                  }, null, 8, ["label", "value"]))
                                                                }), 128))
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : _createCommentVNode("", true),
                                                    (
                          _ctx.catalogs &&
                          _ctx.catalogs.find(ca => ca._id === c.catalogId)
                        )
                                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                          key: 1,
                                                          label: "Size"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_el_select, {
                                                              modelValue: c.size,
                                                              "onUpdate:modelValue": ($event: any) => ((c.size) = $event),
                                                              placeholder: "Select size"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogs.find(
                              ca => ca._id === c.catalogId
                            ).sizes, (co) => {
                                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                                    key: co.code,
                                                                    label: co.name,
                                                                    value: co.code
                                                                  }, null, 8, ["label", "value"]))
                                                                }), 128))
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["title"]))
                            }), 128))
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_el_button, {
                            loading: _ctx.isLoadingAction,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSubmitMapping()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, { class: "mt-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table, {
                        data: _ctx.state.variantMapping.catalogs,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "variant",
                            label: "Variant"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.state.variantMapping.title), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "code",
                            label: "Catalog code"
                          }, {
                            default: _withCtx((scope) => [
                              (
                  scope.row.catalogVariants &&
                  scope.row.catalogVariants.length > 0
                )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(scope.row.catalogVariants[0].code), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "quantity",
                            label: "Quantity"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "cost",
                            label: "Cost"
                          }, {
                            default: _withCtx((scope) => [
                              (_ctx.getVariant(scope.row) && _ctx.getVariant(scope.row).cost)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.getVariant(scope.row).cost), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_16, "0"))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}